import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './PoliticaCookies.css';

export default function PoliticaCookies() {
    const navigate = useNavigate();

    return (
        <div className="politica-page-wrapper">
            <div className="politica-container">
                <div className="politica-card">
                    {/* Botón Volver */}
                    <button onClick={() => navigate(-1)} className="politica-volver-btn">
                        <FontAwesomeIcon icon={faArrowLeft} className="volver-icon" /> Volver
                    </button>

                    {/* Título principal */}
                    <h1 className="politica-title">POLÍTICA DE COOKIES</h1>
                    <div className="politica-title-underline"></div>

                    {/* Introducción destacada */}
                    <div className="politica-intro">
                        <p>
                            <strong>SOCIOS.COM.CO</strong> informa a través de la presente política el uso de las cookies en su plataforma.
                        </p>
                    </div>

                    {/* Secciones detalladas */}
                    <div className="politica-body">
                        <section className="politica-section">
                            <h2>1. ¿QUÉ SON?</h2>
                            <p>
                                Son herramientas usadas para la prestación de servicios. Le permiten a un sitio web almacenar y recuperar información sobre los hábitos de navegación de los usuarios o de sus dispositivos, información que puede ser usada para mejorar los servicios brindados.
                            </p>
                        </section>

                        <section className="politica-section">
                            <h2>2. DEFINICIONES</h2>
                            
                            <div className="politica-definition-block">
                                <p><strong>Datos de registro:</strong></p>
                                <p>
                                    Nuestros servidores registran automáticamente la información que se crea a partir del uso que hace el usuario de los servicios. La Información de Registro puede incluir información como su dirección IP, tipo de navegador, sistema operativo, la página web de procedencia, páginas web visitadas, ubicación, su proveedor de servicios de telefonía móvil, identidad del aparato y de la aplicación, términos de búsqueda e información de cookies. Recibimos Información de Registro cuando el usuario interactúa con nuestros servicios, por ejemplo, cuando visita nuestros sitios web, se suscribe a nuestros servicios, interactúa con nuestras notificaciones por correo electrónico, utiliza su cuenta de SOCIOS PRO para autenticarse ante un sitio web o aplicación de terceros o visita un sitio web de tercero que incluye un botón o widget de SOCIOS.COM.CO hace uso de los Datos de Registro para proporcionar, medir, personalizar y mejorar los servicios.
                                </p>
                            </div>

                            <div className="politica-definition-block">
                                <p><strong>Terceros:</strong></p>
                                <p>
                                    SOCIOS.COM.CO sirve de terceros para prestar sus servicios, específicamente para el alojamiento de distintos perfiles en redes sociales y para entender el uso de los servicios que ofrece, como Google Analytics. Estos proveedores de servicios pueden recoger información enviada por su navegador como parte de una petición de una página web, por ejemplo, cookies o dirección IP.
                                </p>
                                <p>
                                    Es posible que nuestros socios comerciales compartan información con nosotros, como un ID de cookies del navegador o hash criptográfico de un identificador de cuenta común (como una dirección de correo electrónico) para ayudarnos a evaluar la calidad de los anuncios y a personalizarlos.
                                </p>
                                <p>
                                    Lo anterior, nos permite mostrar anuncios sobre cosas en las que el usuario ha mostrado interés.
                                </p>
                            </div>

                            <div className="politica-definition-block">
                                <p><strong>Cookies Propias:</strong></p>
                                <p>Cookies que se envían al dispositivo del usuario desde un dispositivo desde el que se presta el servicio.</p>
                            </div>

                            <div className="politica-definition-block">
                                <p><strong>Cookies de terceros:</strong></p>
                                <p>Cookies que se envían al dispositivo del usuario desde un dispositivo ajeno al prestador del servicio, debido a que un tercero trata los datos que se obtienen a través de las cookies.</p>
                            </div>

                            <div className="politica-definition-block">
                                <p><strong>Cookies de Sesión:</strong></p>
                                <p>Están diseñadas para reconocer a los usuarios en un sitio web.</p>
                            </div>

                            <div className="politica-definition-block">
                                <p><strong>Cookies Persistentes:</strong></p>
                                <p>Los datos permanecen almacenados en el terminal y pueden ser accedidos y tratados durante un periodo definido por el responsable de la cookie.</p>
                            </div>

                            <div className="politica-definition-block">
                                <p><strong>Cookies Técnicas:</strong></p>
                                <p>Le permiten al usuario la navegación a través de la página web y el uso de los servicios que en ella se ofrecen, por ejemplo, conservar elementos que conforman un pedido y tramitar el proceso de compra de estos.</p>
                            </div>

                            <div className="politica-definition-block">
                                <p><strong>Cookies de Personalización:</strong></p>
                                <p>Permiten que el usuario acceda a los servicios con unas características previamente definidas, por ejemplo, los idiomas, navegadores, entre otros.</p>
                            </div>

                            <div className="politica-definition-block">
                                <p><strong>Cookies de Análisis:</strong></p>
                                <p>Le permiten al responsable realizar un seguimiento y análisis del comportamiento de los usuarios. La finalidad de estas cookies es medir la actividad de los usuarios en el sitio web, buscando mejorar la experiencia de estos.</p>
                            </div>

                            <div className="politica-definition-block">
                                <p><strong>Cookies Publicitarias:</strong></p>
                                <p>Facilitan el manejo y gestión de espacios publicitarios dentro del sitio web.</p>
                            </div>

                            <div className="politica-definition-block">
                                <p><strong>Cookies de Publicidad Comportamental:</strong></p>
                                <p>Permiten almacenar información de la actividad del usuario observando sus hábitos, por lo que facilitan el desarrollo determinados espacios publicitarios en función de dicha actividad.</p>
                            </div>

                            <div className="politica-definition-block">
                                <p><strong>Cookies de Redes Sociales Externas:</strong></p>
                                <p>Permiten que el usuario interactúe con contenido de redes sociales. Este tipo de Cookies se regula por las políticas de privacidad de cada una de las redes sociales.</p>
                            </div>
                        </section>

                        <section className="politica-section">
                            <h2>3. DESACTIVACIÓN Y ELIMINACIÓN DE COOKIES</h2>
                            <p>
                                El usuario tiene la capacidad de permitir, modificar, bloquear o eliminar las cookies instaladas en su equipo a través de la configuración del navegador que tenga instalado en su dispositivo.
                            </p>
                            <p>
                                Cuando el usuario desactiva las cookies algunos de servicios podrían dejar funcionar.
                            </p>
                        </section>

                        <section className="politica-section">
                            <h2>4. COOKIES UTILIZADAS POR SOCIOS.COM.CO</h2>
                            <p>
                                Como muchos sitios web, utilizamos cookies y tecnologías similares para recopilar datos adicionales sobre el uso del sitio web con el fin de mejorar nuestros servicios.
                            </p>
                            <p>
                                SOCIOS.COM.CO hace uso tanto cookies de sesión como cookies de persistencia, buscando entender mejor cómo interactúa el usuario con nuestros servicios, monitorizar el uso agregado por parte de nuestros usuarios y el enrutamiento de tráfico web en nuestros servicios, así como personalizar y mejorar los mismos. La mayoría de los navegadores de Internet aceptan cookies automáticamente, pero el usuario puede cambiar la configuración del navegador para modificar esto o para que se le pregunte antes en los sitios web que visita. Sin embargo, algunos servicios pueden no funcionar correctamente si deshabilitan las cookies.
                            </p>
                        </section>

                        <section className="politica-section">
                            <h2>5. ACEPTACIÓN DE LA POLÍTICA DE COOKIES</h2>
                            <p>
                                El usuario acepta el uso de cookies al dar click en el botón “Aceptar” que se muestra al inicio de la página. Sin embargo, se muestra información sobre la Política de Cookies en la parte inferior con cada inicio de sesión y en cada página web, con el fin de que el usuario conozca la existencia de esta.
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}
